import {Component, forwardRef, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { IwgSelectService } from 'src/app/shared/services/iwgselect.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {catchError} from 'rxjs/operators';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CurrencySelectComponent),
  multi: true
};

@Component({
  selector: 'app-currency-select',
  templateUrl: './currency-select.component.html',
  styleUrls: ['./currency-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class CurrencySelectComponent implements OnInit,ControlValueAccessor {

  @Input("preselected-item-id") preselectedItemId:any;
  @Input("refresh-on-preselect") refreshOnPreselect:boolean;
  @Input("selected-country-id") selectedCountryId:any;
  @Input() helptext="";
  @Input() label="Currency";
  @Input("is-disabled") isDisabled:boolean = false;
  @Input("add-united-states") addUnitedStates:boolean;
  @Input() required = false;

  isLoading:boolean = false;
  isOpen:boolean = false;
  ShowHelp:boolean = false;

  items:IwgSelect[] = [];
  idOnly = false;

  constructor(private selectService:IwgSelectService) { }

  private innerValue: any = '';
  get value(): any {return this.innerValue;};
  set value(v: any) {
      if (v !== this.innerValue) {
        this.innerValue = v;this.onChangeCallback(v);
      }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  ngOnInit(): void {
    if (this.helptext != '' && this.helptext != null ) {
      this.ShowHelp = true;
    }
  }
  ngOnChanges(changes: SimpleChanges){
    if ('preselectedItemId' in changes) {
      if(this.preselectedItemId != null){
        this.get(true);
      }
    }
  }
  get(setId=false){
    this.selectService.getCurrency().subscribe(result => {
              this.isLoading = false;
              if (result.apiCallStatus && result.data) {
                this.items = result.data.Data;
                if(this.preselectedItemId != null && setId && this.items){
                  if(this.idOnly){
                    this.value = this.items.find(item=>item.Abbreviation == this.preselectedItemId)
                  }else{
                    this.value = this.items.find(item=>item.ID == this.preselectedItemId)
                  }
                }
              }
            },
            error => {
              this.isLoading = false;
              console.log(error);
            });
  }
  onOpen(event){
    this.isOpen = event;
    if(!event || this.items.length>0){
      return;
    } 
    this.isLoading = true;
    this.selectService.getCurrency().subscribe(
      data=>{
        this.isLoading = false;
        this.items = data.data.Data;
      },
      err=>{
        this.isLoading = false;
        console.log(err);
      }
    );
  }
  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return option.ID === value.ID;
  }
}
